/**
 * Schema of EmailAuditoria
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import EmailNivel from '@/model/resource/EmailNivel'

export default (model: EmailNivel): Schema => ({
  idEmailNivelPk: {
    content: model.idEmailNivelPk,
    editable: false,
  },

  titulo: {
    content: model.titulo,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },
})
